var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-number-field",class:[
    _vm.sizeClass,
    {
      'is-block': _vm.block,
      'is-disabled': _vm.disabled,
      'has-prefix': Boolean(_vm.prefix),
      'has-unit': Boolean(_vm.unit)
    }
  ]},[(_vm.prefix)?_c('span',{staticClass:"ui-number-field__addon ui-number-field__prefix"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_c('el-input-number',_vm._g(_vm._b({ref:"control",staticClass:"ui-number-input",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'el-input-number',_vm.$attrs,false),_vm.forwardedListeners)),(_vm.unit)?_c('span',{staticClass:"ui-number-field__addon ui-number-field__unit"},[_vm._v(_vm._s(_vm.$t(_vm.unit)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }